"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoreSubNavMenu = exports.MoreSubNavLink = exports.MoreSubNavItem = exports.MoreNestedSubNavMenu = exports.MoreNavSubItem = exports.MoreNavNestedLink = exports.MoreNavLabel = exports.MoreNavItem = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _HeaderNav = require("./HeaderNav2025.style");
var _Text = _interopRequireDefault(require("../../../Atoms/Text/Text"));
const MoreSubNavMenu = exports.MoreSubNavMenu = (0, _styledComponents.default)(_HeaderNav.SubNavMenu).withConfig({
  displayName: "MoreNavstyle__MoreSubNavMenu",
  componentId: "sc-68lngb-0"
})(["@media ", "{}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.allBreakpoints('Nav');
});
const MoreNavLabel = exports.MoreNavLabel = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "MoreNavstyle__MoreNavLabel",
  componentId: "sc-68lngb-1"
})(["@media ", "{position:relative;font-size:15px;line-height:16px;padding:10px 15px 10px 0;display:flex;:before{content:'';position:absolute;width:0;height:70%;top:50%;left:-23px;transform:translateY(-50%);border-left:2px solid ", ";border-radius:2px;pointer-events:none;}:}@media ", "{font-size:1rem;:before{content:'';position:absolute;width:0;height:70%;top:50%;left:-21px;transform:translateY(-50%);border-left:2px solid ", ";border-radius:2px;}:}"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.allBreakpoints('Nav');
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.color('grey_medium');
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.allBreakpoints('NavWide');
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.color('grey_medium');
});

// Use for the 'More' link only
const MoreNavItem = exports.MoreNavItem = (0, _styledComponents.default)(_HeaderNav.NavItem).withConfig({
  displayName: "MoreNavstyle__MoreNavItem",
  componentId: "sc-68lngb-2"
})(["@media ", "{margin-left:22px;display:flex;flex-grow:1;", " > ", "{transition:transform 0.35s cubic-bezier(0.41,1.64,0.41,0.8);}:hover,:focus{", "{color:", ";> ", "{transform:rotate(-180deg);img{filter:invert(0.5) sepia(1) saturate(100) hue-rotate(20deg);}}}}:hover,:focus,:focus-within{> ", "{border-bottom:none;padding-bottom:10px;}> ", "{visibility:visible;opacity:1;display:flex;flex-direction:column;}}:focus{> ", "{visibility:hidden !important;opacity:0 !important;display:none !important;}}}@media ", "{margin-left:20px;}"], _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.allBreakpoints('Nav');
}, MoreNavLabel, _HeaderNav.ChevronWrapper, MoreNavLabel, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.color('red');
}, _HeaderNav.ChevronWrapper, MoreNavLabel, MoreSubNavMenu, MoreSubNavMenu, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.allBreakpoints('NavWide');
});

// Clone Of SubNavMenu, NESTED menu
const MoreNestedSubNavMenu = exports.MoreNestedSubNavMenu = (0, _styledComponents.default)(_HeaderNav.SubNavMenu).withConfig({
  displayName: "MoreNavstyle__MoreNestedSubNavMenu",
  componentId: "sc-68lngb-3"
})(["@media ", "{top:0;left:-1px;border-radius:0;border-bottom:0;position:relative;transition:max-height 0.5s cubic-bezier(0.5,1.5,0.5,0.80);max-height:0;border:0;box-shadow:none;", ";}"], _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.allBreakpoints('Nav');
}, _ref10 => {
  let {
    isSubMenuOpen
  } = _ref10;
  return isSubMenuOpen && (0, _styledComponents.css)(["max-height:calc(54px * 8);"]);
});
const MoreSubNavItem = exports.MoreSubNavItem = (0, _styledComponents.default)(_HeaderNav.SubNavItem).withConfig({
  displayName: "MoreNavstyle__MoreSubNavItem",
  componentId: "sc-68lngb-4"
})(["> a > ", "{position:absolute;width:15px;top:13px;right:25px;transition:transform 0.35s cubic-bezier(0.41,1.64,0.41,0.8);}:hover,:focus,:focus-within{> a{color:", ";}> a > ", "{img{filter:invert(0.5) sepia(1) saturate(100) hue-rotate(20deg);}}}"], _HeaderNav.ChevronWrapper, _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.color('red');
}, _HeaderNav.ChevronWrapper);
const MoreNavSubItem = exports.MoreNavSubItem = (0, _styledComponents.default)(MoreSubNavItem).withConfig({
  displayName: "MoreNavstyle__MoreNavSubItem",
  componentId: "sc-68lngb-5"
})(["&:first-of-type{border-top:1px solid ", ";}"], _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.color('grey_medium');
});
const MoreNavNestedLink = exports.MoreNavNestedLink = (0, _styledComponents.default)(_HeaderNav.NavLink).withConfig({
  displayName: "MoreNavstyle__MoreNavNestedLink",
  componentId: "sc-68lngb-6"
})(["padding:20px 30px 22px 30px;> div{height:auto;}", ";"], _ref13 => {
  let {
    isSubMenuOpen
  } = _ref13;
  return isSubMenuOpen && (0, _styledComponents.css)(["color:", ";> ", "{transform:rotate(-180deg);img{filter:invert(0.5) sepia(1) saturate(100) hue-rotate(20deg);}}"], _ref14 => {
    let {
      theme
    } = _ref14;
    return theme.color('red');
  }, _HeaderNav.ChevronWrapper);
});
const MoreSubNavLink = exports.MoreSubNavLink = (0, _styledComponents.default)(_HeaderNav.SubNavLink).withConfig({
  displayName: "MoreNavstyle__MoreSubNavLink",
  componentId: "sc-68lngb-7"
})([""]);